module.exports = __webpack_public_path__ + "img/tnm-logo@2x.7f3b1531.webp";